const VISITORS_AREA_LANGUAGE_STORAGE_KEY = 'sh-language';

/** ISO 639-1 from ngx-translate / localStorage — empty when nothing usable is set. */
export function readVisitorsAreaLanguage(currentLang?: string | null): string | null {
  const fromTranslate = normalizeIso6391(currentLang);
  if (fromTranslate) {
    return fromTranslate;
  }
  try {
    return normalizeIso6391(globalThis.localStorage?.getItem(VISITORS_AREA_LANGUAGE_STORAGE_KEY));
  } catch {
    return null;
  }
}

/**
 * Guest SPA iframe URL. `lang` is the visitors-area UI language so myGuest can match it;
 * guest falls back to English when the code is missing or unsupported.
 */
export function buildMyGuestEmbedUrl(baseUrl: string, token: string, lang?: string | null): string {
  const origin = baseUrl.replace(/\/$/, '');
  const url = `${origin}/c/${encodeURIComponent(token)}?embed=1`;
  const normalized = normalizeIso6391(lang);
  if (!normalized) {
    return url;
  }
  return `${url}&lang=${encodeURIComponent(normalized)}`;
}

function normalizeIso6391(value: string | null | undefined): string | null {
  const raw = (value ?? '').trim().toLowerCase();
  if (!raw) {
    return null;
  }
  const code = raw.split(/[-_]/)[0] ?? '';
  return /^[a-z]{2}$/.test(code) ? code : null;
}
